import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const Locations = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminTravel()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.travelLocation,
      list: REDUCER_KEY.travelLocations
    }}
    config={config}
  />
);

Locations.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Locations;
